import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Interview2QuestionComponent } from './interview2-question.component';


import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    Interview2QuestionComponent,
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [

  ]
})
export class Interview2QuestionModule { }
